<template>
	<div class="activity-audit" :class="{ 'has-auto-footer': isAutoApply }">
		<!-- 顶部提示 -->
		<div class="audit-notice">
			<van-icon name="info-o" class="audit-notice__icon" />
			<span>活动报名通过后，您可以在平台进行创作发布，所有信息仅用于活动报名和平台认证，平台将严格保密。</span>
		</div>

		<van-loading v-if="loading.load" class="audit-loading" size="24px">加载中...</van-loading>

		<template v-else>
			<div class="audit-form">
				<!-- 动态表单 -->
				<div class="audit-card" v-for="(item, index) in authForm" :key="item.id || index">
					<!-- 头像 -->
					<div class="audit-avatar" v-if="item.fieldType === 'avatar'">
						<div class="audit-avatar__label">
							<span class="audit-required" v-if="item.required == 1">*</span>{{ item.fieldName }}
						</div>
						<base-upload
							:value="getAvatarList(item)"
							:limit="1"
							:disabled="isFieldDisabled(item)"
							:repeat-upload="false"
							@input="(val) => handleAvatar(val, item)"
							@success="(list, file) => handleAvatarSuccess(list, file, item)"
						/>
					</div>

					<!-- 银行卡号（未开启支付方式时） -->
					<audit-field
						v-else-if="!isShowPayType && (item.fieldType === 'bankNumber' || item.field === 'bankNumber')"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						:readonly="isFieldDisabled(item)"
						:disabled="isFieldDisabled(item)"
						@input="(val) => inputVal(index, val)"
					/>

					<!-- 开户行（未开启支付方式时） -->
					<audit-field
						v-else-if="!isShowPayType && item.fieldType === 'bankName'"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						placeholder="请选择开户行"
						readonly
						:disabled="isFieldDisabled(item)"
						is-link
						@click="clickSelectBank(index)"
					/>

					<!-- 支行（未开启支付方式时） -->
					<audit-field
						v-else-if="!isShowPayType && (item.fieldType === 'bankBranch' || item.field === 'bankBranch')"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						:readonly="isFieldDisabled(item)"
						:disabled="isFieldDisabled(item)"
						@input="(val) => inputVal(index, val)"
					/>

					<!-- 普通输入 -->
					<audit-field
						v-else-if="item.fieldType === 'input'"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						:readonly="isFieldDisabled(item)"
						:disabled="isFieldDisabled(item)"
						@input="(val) => inputVal(index, val)"
					/>

					<!-- 姓名 / 身份证（只读） -->
					<audit-field
						v-else-if="item.fieldType === 'name' || item.fieldType === 'idcard'"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						readonly
						disabled
					/>

					<!-- 邮箱 -->
					<audit-field
						v-else-if="item.fieldType === 'emil' || item.field === 'emil'"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						:maxlength="64"
						:readonly="isFieldDisabled(item)"
						:disabled="isFieldDisabled(item)"
						@input="(val) => inputVal(index, val)"
					/>

					<!-- 医院 -->
					<audit-field
						v-else-if="item.fieldType === 'hospitalName'"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						placeholder="请选择医院"
						readonly
						:disabled="isFieldDisabled(item)"
						is-link
						@click="clickSelectHospital(index)"
					/>

					<!-- 科室 -->
					<audit-field
						v-else-if="item.fieldType === 'deptName'"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						placeholder="请选择科室"
						readonly
						:disabled="isFieldDisabled(item)"
						is-link
						@click="clickSelectDept(index)"
					/>

					<!-- 职称 -->
					<audit-field
						v-else-if="item.fieldType === 'title'"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						placeholder="请选择职称"
						readonly
						:disabled="isFieldDisabled(item)"
						is-link
						@click="clickSelectTitle(index)"
					/>

					<!-- 下拉选择 -->
					<audit-field
						v-else-if="item.fieldType === 'select'"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						placeholder="请选择"
						readonly
						:disabled="isFieldDisabled(item)"
						is-link
						@click="clickSelectTitle(index)"
					/>

					<!-- 省市区 -->
					<audit-field
						v-else-if="item.fieldType === 'province'"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						placeholder="请选择"
						readonly
						:disabled="isFieldDisabled(item)"
						is-link
						@click="clickSelectArea(index, 'province-city')"
					/>

					<!-- 地区 -->
					<audit-field
						v-else-if="item.fieldType === 'area'"
						:value="item.fieldValue"
						:label="item.fieldName"
						:required="item.required == 1"
						placeholder="请选择"
						readonly
						:disabled="isFieldDisabled(item)"
						is-link
						@click="clickSelectArea(index, '')"
					/>

					<!-- 多图上传 -->
					<audit-upload-card
						v-else-if="item.fieldType === 'upload'"
						:value="item.fieldValue"
						:title="item.fieldName"
						:required="item.required == 1"
						:limit="10"
						:disabled="isFieldDisabled(item)"
						@input="(val) => handleUploadChange(val, item)"
					/>

					<!-- 身份证 -->
					<audit-idcard-upload
						v-else-if="item.fieldType === 'idCardPhoto'"
						:value="item.fieldValue"
						:disabled="isFieldDisabled(item)"
						@change="(val) => handleIdcardChange(val, item)"
					/>

					<!-- 医师执业证书 -->
					<audit-upload-card
						v-else-if="item.fieldType === 'employmentPhoto'"
						:value="item.fieldValue"
						title="上传《医师执业证书》"
						:required="item.required == 1"
						:limit="10"
						:disabled="isFieldDisabled(item)"
						:show-wjw="activityDetail.showWjw == 1"
						desc="请上传《医师执业证书》的所有内容页面（含变更页）的原证件照片，不得遮挡、缺损，最多上传5张"
						example-title="《医师执业证书》示例"
						example-desc="请上传《医师执业证书》的彩色原证件照片，不得遮挡、缺损，示例如下"
						:example-labels="['国徽页、照片页', '个人信息及变更页', '变更页']"
						:example-list="zyExampleList"
						@input="(val) => handleUploadChange(val, item)"
					/>

					<!-- 职称证书 -->
					<audit-upload-card
						v-else-if="item.fieldType === 'titlePhoto'"
						:value="item.fieldValue"
						:title="'上传《' + (item.fieldName || '职称证书') + '》'"
						:required="item.required == 1"
						:limit="10"
						:disabled="isFieldDisabled(item)"
						:desc="'请上传' + (item.fieldName || '职称证书') + '的彩色原证件照片，不得遮挡、缺损,最多上传5张'"
						:example-title="'《' + (item.fieldName || '职称证书') + '》示例'"
						:example-desc="'请上传' + (item.fieldName || '职称证书') + '的彩色原证件照片，不得遮挡、缺损,示例如下'"
						:example-labels="['医师职称证 主页']"
						:example-list="zcExampleList"
						@input="(val) => handleUploadChange(val, item)"
					/>
				</div>

				<!-- 支付方式 -->
				<div class="audit-card" v-if="isShowPayType">
					<audit-field
						:value="payTypeItem.text || ''"
						label="支付方式"
						placeholder="请选择支付方式"
						readonly
						:disabled="isAutoApply || disabledSelectPayTypeItem"
						is-link
						@click="payTypePickerVisible = true"
					/>
					<div class="audit-paytype-notice" v-if="payTypeItem.value == 4">
						<van-icon name="warning-o" class="audit-paytype-notice__icon" />
						<span>天猫卡支付，活动完成并审核通过后，请前往我的-数字资产中自行兑换天猫卡</span>
					</div>
					<template v-if="payTypeItem.value == 2">
						<audit-field
							v-if="payTypeBankParams.bankName"
							:value="payTypeBankParams.bankName.fieldValue"
							:label="payTypeBankParams.bankName.fieldName"
							:required="payTypeBankParams.bankName.required == 1"
							placeholder="请选择开户行"
							readonly
							:disabled="isAutoApply || isFieldDisabled(payTypeBankParams.bankName)"
							is-link
							@click="clickSelectBank(payTypeBankParams.bankName.itemIndex)"
						/>
						<audit-field
							v-if="payTypeBankParams.bankBranch"
							:value="payTypeBankParams.bankBranch.fieldValue"
							:label="payTypeBankParams.bankBranch.fieldName"
							:required="payTypeBankParams.bankBranch.required == 1"
							:readonly="isAutoApply || isFieldDisabled(payTypeBankParams.bankBranch)"
							:disabled="isAutoApply || isFieldDisabled(payTypeBankParams.bankBranch)"
							@input="inputBankBranch"
						/>
						<audit-field
							v-if="payTypeBankParams.bankNumber"
							:value="payTypeBankParams.bankNumber.fieldValue"
							:label="payTypeBankParams.bankNumber.fieldName"
							:required="payTypeBankParams.bankNumber.required == 1"
							:readonly="isAutoApply || isFieldDisabled(payTypeBankParams.bankNumber)"
							:disabled="isAutoApply || isFieldDisabled(payTypeBankParams.bankNumber)"
							@input="inputBankNumber"
						/>
					</template>
				</div>

				<!-- 自动审核签名展示 -->
				<div class="audit-card" v-if="isAutoApply && publicUserInfo.signUrlOriginal">
					<div class="audit-card__title">签名</div>
					<div class="audit-card__body">
						<img class="audit-sign" :src="publicUserInfo.signUrlOriginal" alt="" />
					</div>
				</div>

				<!-- 未自动审核时的提交按钮区 -->
				<div class="audit-submit" v-if="!isAutoApply">
					<div class="audit-submit__footer" v-if="!activityDetail.auditStatus || activityDetail.auditStatus == 3">
						<van-button
							v-if="!isAllowSubmit"
							type="primary"
							block
							class="audit-submit__btn audit-submit__btn--disabled"
							@click="clickShowSubmitErrorToast"
						>提交审核</van-button>
						<van-button
							v-else-if="loading.submit"
							type="primary"
							block
							class="audit-submit__btn"
							loading
						>提交审核</van-button>
						<van-button
							v-else
							type="primary"
							block
							class="audit-submit__btn"
							@click="clickSubmit"
						>提交审核</van-button>
					</div>
					<div class="audit-submit__footer" v-else>
						<van-button type="primary" block class="audit-submit__btn" disabled>
							{{ activityDetail.auditStatus == 1 ? '审核中' : '已报名' }}
						</van-button>
					</div>
				</div>
			</div>
		</template>

		<!-- 自动审核底部栏 -->
		<base-footer v-if="isAutoApply" background-color="#ffffff">
			<div class="audit-auto-footer">
				<div class="audit-auto-footer__bar">
					<div class="audit-auto-footer__sub" v-if="showUpdateButton">
						<van-button block @click="clickModifyInfor">修改资料</van-button>
					</div>
					<div class="audit-auto-footer__main">
						<van-button type="primary" block @click="clickSubmit">授权并提交</van-button>
					</div>
				</div>
				<div class="audit-auto-footer__desc">您在平台有审核通过的认证资料，是否授权本次使用</div>
			</div>
		</base-footer>

		<!-- 协议弹窗 -->
		<van-popup v-model="agreement.visible" round class="audit-agreement">
			<div class="audit-agreement__title">
				<span>{{ agreement.title }}</span>
				<van-icon class="audit-agreement__close" name="cross" @click="clickCloseDialog" />
			</div>
			<div class="audit-agreement__body">
				<img
					class="audit-agreement__img"
					:src="activityDetail.agreementUrl"
					@click="clickPreview"
				/>
			</div>
			<div class="audit-agreement__handle">
				<van-button type="primary" block size="small" @click="clickSignUp">去签署</van-button>
			</div>
		</van-popup>

		<!-- 选择器弹层 -->
		<audit-picker
			v-model="pickerVisible"
			:title="pickerTitle"
			:columns="pickerOptions"
			@confirm="onPickerConfirm"
		/>
		<audit-picker
			v-model="payTypePickerVisible"
			title="选择支付方式"
			:columns="payTypeOptions"
			@confirm="clickSelectPayType"
		/>
		<audit-area-picker
			v-model="areaPickerVisible"
			:label="areaPickerLabel"
			:format-type="areaFormatType"
			@confirm="onAreaConfirm"
		/>
		<audit-department-picker v-model="departmentPickerVisible" @confirm="onDeptConfirm" />
		<audit-search-picker
			v-model="hospitalPickerVisible"
			title="选择医院"
			placeholder="请输入医院名称搜索"
			:request="searchHospital"
			@confirm="onHospitalConfirm"
		/>
		<audit-search-picker
			v-model="bankPickerVisible"
			title="选择开户行"
			placeholder="请输入银行名称搜索"
			icon="debit-pay"
			:request="searchBank"
			@confirm="onBankConfirm"
		/>
	</div>
</template>

<script>
import { Dialog, ImagePreview } from 'vant'
import AuditField from './components/audit-field.vue'
import AuditPicker from './components/audit-picker.vue'
import AuditAreaPicker from './components/audit-area-picker.vue'
import AuditDepartmentPicker from './components/audit-department-picker.vue'
import AuditSearchPicker from './components/audit-search-picker.vue'
import AuditUploadCard from './components/audit-upload-card.vue'
import AuditIdcardUpload from './components/audit-idcard-upload.vue'

export default {
	name: 'ActivityAudit',
	components: {
		AuditField,
		AuditPicker,
		AuditAreaPicker,
		AuditDepartmentPicker,
		AuditSearchPicker,
		AuditUploadCard,
		AuditIdcardUpload,
	},
	data: () => ({
		options: {},
		agreement: {
			visible: false,
			title: '签署协议',
			message: '',
		},
		isAllowSubmit: false,
		isAllowSubmitErrorMessage: '',
		isAutoApply: false,
		isAutoApplyUpdate: false,
		activityDetail: {},
		authForm: [],
		oldAuthForm: [],
		loading: {
			submit: false,
			load: false,
			title: false,
		},
		titleOptions: [],
		// 支付方式参数
		isShowPayType: false,
		disabledSelectPayTypeItem: false,
		payTypeItem: {},
		payTypeBankParams: {
			bankName: null,
			bankNumber: null,
			bankBranch: null,
		},
		payTypeOptions: [
			{ value: 2, text: '银行卡支付' },
			{ value: 4, text: '天猫卡密支付' },
		],
		publicUserInfo: {},
		// 头像本地上传列表（保持数组引用连续，避免上传中列表被清空）
		avatarFileMap: {},
		// 选择器
		pickerVisible: false,
		pickerTitle: '',
		pickerOptions: [],
		pickerIndex: -1,
		payTypePickerVisible: false,
		areaPickerVisible: false,
		areaPickerLabel: '地区',
		areaFormatType: '',
		areaPickerIndex: -1,
		departmentPickerVisible: false,
		departmentPickerIndex: -1,
		hospitalPickerVisible: false,
		hospitalPickerIndex: -1,
		bankPickerVisible: false,
		bankPickerIndex: -1,
		selectHospital: {},
		selectDeptment: {},
	}),
	computed: {
		user() {
			return this.$store.getters['user/getLoginInfo']
		},
		// 当前登录医生ID
		doctorId() {
			return this.user.userId || this.user.id || ''
		},
		fileBaseUrl() {
			return this.$config[this.$store.getters['user/getAppid']].fileBaseUrl
		},
		// 医师执业证书示例图
		zyExampleList() {
			return [
				`${this.fileBaseUrl}/view-example-01.png`,
				`${this.fileBaseUrl}/view-example-02.png`,
				`${this.fileBaseUrl}/view-example-03.png`,
			]
		},
		// 职称证书示例图
		zcExampleList() {
			return [`${this.fileBaseUrl}/title-example-01.png`]
		},
		// 是否需要展示修改资料按钮
		showUpdateButton() {
			const doctorCanEditFields = this.activityDetail.doctorCanEditFields
			if (!doctorCanEditFields) return false
			const arr = doctorCanEditFields.split(',')
			return this.authForm.some((f) => arr.indexOf(f.fieldName) !== -1)
		},
	},
	created() {
		this.options = { ...this.$route.query }
		this.getDict()
		this.getPublicUserInfo()
	},
	methods: {
		// 获取职称列表
		getDict() {
			this.loading.title = true
			this.$api.cpnt
				.titlePage()
				.then((res) => {
					this.loading.title = false
					if (!res.code) {
						this.titleOptions = res.data.map((item) => ({
							text: item.title,
							value: item.code,
						}))
					}
				})
				.catch(() => {
					this.loading.title = false
				})
		},
		// 获取公共库医生信息
		getPublicUserInfo() {
			if (!this.doctorId) return
			this.$api.account
				.getPublicUserInfo({ activityId: this.options.activityId, id: this.doctorId })
				.then((res) => {
					if (!res.code && res.data) {
						res.data.practicingCertificates = []
						res.data.titleCertificates = []
						;(res.data.doctorCertList || []).forEach((item) => {
							if (item.certType == 1) res.data.idCardFrontUrl = item
							if (item.certType == 2) res.data.idCardBackurl = item
							if (item.certType == 3) res.data.practicingCertificates.push(item)
							if (item.certType == 5) res.data.titleCertificates.push(item)
						})
						this.publicUserInfo = res.data || {}
						this.getActivityDetail()
					}
				})
		},
		// 获取活动信息
		getActivityDetail() {
			this.loading.load = true
			this.$api.activity
				.activityDetail({
					id: this.options.activityId,
					doctorId: this.doctorId,
				})
				.then((res) => {
					this.loading.load = false
					if (!res.code && res.data) {
						if (!res.data.activityDoctorDTO) {
							Dialog.alert({
								title: '温馨提示',
								message: '当前账号暂时无法报名参与该活动',
								confirmButtonText: '知道了',
							}).then(() => {
								this.$router.back()
							})
							return
						}
						if (res.data.organAutoAudit) {
							this.autoApplyMethod(res.data)
						} else {
							this.defaultMethod(res.data)
						}
					}
				})
				.catch((err) => {
					console.log('getActivityDetail error ===>', err)
					this.loading.load = false
				})
		},
		// 活动自动审核逻辑
		autoApplyMethod(detail) {
			if (detail.auditStatus) {
				this.defaultMethod(detail)
				return
			}
			if (!this.publicUserInfo.signUrlOriginal) {
				this.defaultMethod(detail)
				return
			}
			const formArr = JSON.parse(detail.formJson)
			if (!this.checkIsAllStandardFields(formArr)) {
				this.defaultMethod(detail)
				return
			}
			const authFormAndStatus = this.setAuthFormAndStatus(formArr)
			const payTypeRes = this.payTypeFormat(detail, authFormAndStatus.authForm)
			this.activityDetail = detail
			Object.assign(this, payTypeRes, authFormAndStatus)
			this.$nextTick(() => this.formVerify())
		},
		// 判断是否全部都是标准字段组成
		checkIsAllStandardFields(list) {
			const standardFields = ['avatar', 'name', 'hospitalName', 'deptName', 'title', 'idcard', 'area', 'province', 'idCardPhoto', 'employmentPhoto', 'titlePhoto', 'bankName', 'bankNumber', 'bankBranch']
			return list.every((item) => standardFields.includes(item.fieldType))
		},
		setAuthFormAndStatus(list) {
			const publicUserInfo = this.publicUserInfo
			let isAutoApply = true
			const authForm = list.map((item) => {
				item.isUpdate = 0 // 是否有修改动作
				switch (item.fieldType) {
					case 'avatar':
						item.fieldValue = this.getAuthFormItemVal(1, 'avatar')
						isAutoApply = isAutoApply && !!publicUserInfo.avatar
						break
					case 'name':
						item.fieldValue = this.getAuthFormItemVal(1, 'name')
						isAutoApply = isAutoApply && !!publicUserInfo.name
						break
					case 'hospitalName':
						item.fieldValue = this.getAuthFormItemVal(1, 'hospitalName')
						isAutoApply = isAutoApply && !!publicUserInfo.hospitalName
						break
					case 'deptName':
						item.fieldValue = this.getAuthFormItemVal(1, 'deptName')
						isAutoApply = isAutoApply && !!publicUserInfo.deptName
						break
					case 'title':
						item.fieldValue = this.getAuthFormItemVal(1, 'title')
						isAutoApply = isAutoApply && !!publicUserInfo.title
						break
					case 'idcard':
						item.fieldValue = this.getAuthFormItemVal(1, 'idcard')
						isAutoApply = isAutoApply && !!publicUserInfo.idcard
						break
					case 'area':
						item.fieldValue = this.getAuthFormItemVal(1, 'area')
						isAutoApply = isAutoApply && !!publicUserInfo.area
						break
					case 'province':
						item.fieldValue = this.getAuthFormItemVal(1, 'province')
						isAutoApply = isAutoApply && !!publicUserInfo.province
						break
					case 'idCardPhoto':
						item.fieldValue = this.getAuthFormItemVal(1, 'idCardPhoto')
						isAutoApply = isAutoApply && this.checkArrExistFileUrl([publicUserInfo.idCardFrontUrl, publicUserInfo.idCardBackurl])
						break
					case 'employmentPhoto':
						item.fieldValue = this.getAuthFormItemVal(1, 'employmentPhoto')
						isAutoApply = isAutoApply && this.checkArrExistFileUrl(publicUserInfo.practicingCertificates)
						break
					case 'titlePhoto':
						item.fieldValue = this.getAuthFormItemVal(1, 'titlePhoto')
						isAutoApply = isAutoApply && this.checkArrExistFileUrl(publicUserInfo.titleCertificates)
						break
					case 'bankName':
						item.fieldValue = this.getAuthFormItemVal(1, 'bankName')
						isAutoApply = isAutoApply && !!publicUserInfo.bankName
						break
					case 'bankNumber':
						item.fieldValue = this.getAuthFormItemVal(1, 'bankNumber')
						isAutoApply = isAutoApply && !!publicUserInfo.bankNumber
						break
					case 'bankBranch':
						item.fieldValue = this.getAuthFormItemVal(1, 'bankBranch')
						isAutoApply = isAutoApply && !!publicUserInfo.bankBranch
						break
				}
				return item
			})
			const oldAuthForm = JSON.parse(JSON.stringify(authForm))
			return { authForm, isAutoApply, oldAuthForm }
		},
		checkArrExistFileUrl(list) {
			if (!list) return false
			if (!list.length) return false
			return list.some((item) => item && item.fileUrl)
		},
		// 默认逻辑
		defaultMethod(detail) {
			const authForm = this.computedAuthForm(detail)
			const payTypeRes = this.payTypeFormat(detail, authForm)
			this.isAutoApply = false
			this.activityDetail = detail
			Object.assign(this, payTypeRes)
			this.authForm = authForm
			this.oldAuthForm = JSON.parse(JSON.stringify(authForm))
			this.$nextTick(() => this.formVerify())
		},
		// 获取form表单序列表
		computedAuthForm({ formJson, auditStatus, activityDoctorDTO, isDoctorPublic }) {
			if (!auditStatus) {
				const list = formJson ? JSON.parse(formJson) : []
				list.forEach((item) => {
					switch (item.fieldType) {
						case 'avatar':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'avatar')
							break
						case 'name':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'name')
							break
						case 'idcard':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'idcard')
							break
						case 'hospitalName':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'hospitalName')
							break
						case 'deptName':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'deptName')
							break
						case 'emil':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'emil')
							break
						case 'title':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'title')
							break
						case 'bankName':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'bankName')
							break
						case 'bankNumber':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'bankNumber')
							break
						case 'bankBranch':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'bankBranch')
							break
						case 'idCardPhoto':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'idCardPhoto')
							break
						case 'employmentPhoto':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'employmentPhoto')
							break
						case 'titlePhoto':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'titlePhoto')
							break
						case 'province':
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'province')
							break
						case 'upload':
							item.fieldValue = []
							break
						case 'select':
							{
								const options = JSON.parse(item.ext)
								options.forEach((i) => {
									i.value = i.id
								})
								item.ext = options
							}
							break
					}
					switch (item.field) {
						case 'bankNumber':
							item.fieldType = 'bankNumber'
							item.fieldValue = this.getAuthFormItemVal(isDoctorPublic, 'bankNumber')
							break
					}
				})
				return list
			}
			if (activityDoctorDTO.deptId) {
				this.selectDeptment.id = activityDoctorDTO.deptId
			}
			if (activityDoctorDTO.hospitalId) {
				this.selectHospital.id = activityDoctorDTO.hospitalId
			}
			return activityDoctorDTO.formCommitJson ? JSON.parse(activityDoctorDTO.formCommitJson) : {}
		},
		// 获取authForm字段默认值
		getAuthFormItemVal(isDoctorPublic, key) {
			if (['name', 'idcard'].includes(key)) {
				return this.publicUserInfo[key] || ''
			} else if (isDoctorPublic) {
				if (key === 'deptName') {
					this.selectDeptment.id = this.publicUserInfo.deptId
				}
				if (key === 'hospitalName') {
					this.selectHospital.id = this.publicUserInfo.hospitalId
				}
				if (key === 'idCardPhoto') {
					return [this.publicUserInfo.idCardFrontUrl?.fileUrl || '', this.publicUserInfo.idCardBackurl?.fileUrl || '']
				}
				if (key === 'employmentPhoto') {
					return (this.publicUserInfo.practicingCertificates || []).map((item) => ({ url: item.fileUrl }))
				}
				if (key === 'titlePhoto') {
					return (this.publicUserInfo.titleCertificates || []).map((item) => ({ url: item.fileUrl }))
				}
				return this.publicUserInfo[key] || ''
			} else {
				if (['idCardPhoto', 'employmentPhoto', 'titlePhoto'].includes(key)) return []
				return ''
			}
		},
		// 支付方式的逻辑
		payTypeFormat(data, authForm) {
			// 是否显示支付方式的处理
			let isShowPayType = false
			let payTypeItem = this.payTypeItem
			let disabledSelectPayTypeItem = false
			const payTypeBankParams = {
				bankName: null,
				bankBranch: null,
				bankNumber: null,
			}
			if (data.payTypeStr) {
				isShowPayType = data.payTypeStr.includes(2) || data.payTypeStr.includes(4)
				if (data.payTypeStr == 2) {
					disabledSelectPayTypeItem = true
					payTypeItem = { text: '银行卡支付', value: 2 }
				} else if (data.payTypeStr == 4) {
					disabledSelectPayTypeItem = true
					payTypeItem = { text: '天猫卡密支付', value: 4 }
				} else if (data.payTypeStr.includes(2) && data.payTypeStr.includes(4)) {
					if (data.organAutoAudit == 1) {
						payTypeItem = { text: '银行卡支付', value: 2 }
					}
				}
			}
			if (data.auditStatus) {
				if (data.activityDoctorDTO && (data.activityDoctorDTO.payType == 2 || data.activityDoctorDTO.payType == 4)) {
					if (data.activityDoctorDTO.payType == 2) {
						payTypeItem = { text: '银行卡支付', value: 2 }
					}
					if (data.activityDoctorDTO.payType == 4) {
						payTypeItem = { text: '天猫卡密支付', value: 4 }
					}
				}
			}
			const bankNameIndex = authForm.findIndex((item) => item.fieldType == 'bankName')
			if (bankNameIndex > -1) {
				payTypeBankParams.bankName = {
					...authForm[bankNameIndex],
					itemIndex: bankNameIndex,
				}
			}
			const bankBranchIndex = authForm.findIndex((item) => item.fieldType == 'bankBranch')
			if (bankBranchIndex > -1) {
				payTypeBankParams.bankBranch = {
					...authForm[bankBranchIndex],
					itemIndex: bankBranchIndex,
				}
			}
			const bankNumberIndex = authForm.findIndex((item) => item.fieldType == 'bankNumber' || item.field == 'bankNumber')
			if (bankNumberIndex > -1) {
				payTypeBankParams.bankNumber = {
					...authForm[bankNumberIndex],
					itemIndex: bankNumberIndex,
				}
			}
			return {
				isShowPayType,
				payTypeItem,
				payTypeBankParams,
				disabledSelectPayTypeItem,
			}
		},
		// 表单校验
		formVerify() {
			let isAllowSubmit = true
			let isAllowSubmitErrorMessage = ''
			if (this.isShowPayType && !this.payTypeItem.value) {
				isAllowSubmit = false
				isAllowSubmitErrorMessage = '支付方式不能为空，请补充后再提交'
			}
			const list = JSON.parse(JSON.stringify(this.authForm))
			for (let i = 0; i < list.length; i++) {
				if (this.isShowPayType && this.payTypeItem.value == 2) {
					if (list[i].fieldType == 'bankName') list[i].required = 1
					if (list[i].fieldType == 'bankNumber') list[i].required = 1
					if (list[i].field == 'bankNumber') list[i].required = 1
				}
				if (list[i].required == 1) {
					if (this.isShowPayType && this.payTypeItem.value == 4) {
						if (list[i].fieldType == 'bankName') continue
						if (list[i].fieldType == 'bankNumber') continue
						if (list[i].field == 'bankNumber') continue
					}
					if (!list[i].fieldValue.length) {
						isAllowSubmit = false
						isAllowSubmitErrorMessage = `${list[i].fieldName}不能为空，请补充后再提交`
						break
					}
					if (list[i].fieldType == 'idCardPhoto') {
						if (!list[i].fieldValue[0]) {
							isAllowSubmit = false
							isAllowSubmitErrorMessage = '身份证人像面不能为空，请补充后再提交'
							break
						}
						if (!list[i].fieldValue[1]) {
							isAllowSubmit = false
							isAllowSubmitErrorMessage = '身份证国徽面不能为空，请补充后再提交'
							break
						}
					}
				}
			}
			this.isAllowSubmit = isAllowSubmit
			this.isAllowSubmitErrorMessage = isAllowSubmitErrorMessage
		},
		// 字段输入
		inputVal(index, value) {
			const list = this.authForm
			const oldList = this.oldAuthForm
			if (!list[index]) return
			list[index].fieldValue = value
			if (this.activityDetail.isCallWjw) {
				if (oldList[index].fieldValue) {
					list[index].isUpdate = 1
				}
			} else {
				list[index].isUpdate = 1
			}
			this.formVerify()
		},
		handleUploadSuccess() {
			this.$toast('上传成功')
		},
		// 头像
		getAvatarList(item) {
			// 优先本地上传列表（引用连续），其次回显 fieldValue
			const local = this.avatarFileMap[item.id]
			if (local !== undefined) return local
			return item.fieldValue ? [{ url: item.fieldValue }] : []
		},
		handleAvatar(val, item) {
			// 选择/删除文件时同步本地列表（此时 url 可能尚未生成）
			this.$set(this.avatarFileMap, item.id, val)
			if (!val.length) {
				item.fieldValue = ''
			} else if (val[0].url) {
				item.fieldValue = val[0].url
			}
			item.isUpdate = 1
			this.formVerify()
		},
		handleAvatarSuccess(list, file, item) {
			this.$toast('上传成功')
			if (file && file.url) {
				item.fieldValue = file.url
				this.$set(this.avatarFileMap, item.id, [{ url: file.url }])
				item.isUpdate = 1
				this.formVerify()
			}
		},
		// 多图上传
		handleUploadChange(val, item) {
			item.fieldValue = val
			item.isUpdate = 1
			this.formVerify()
		},
		// 身份证上传
		handleIdcardChange(val, item) {
			item.fieldValue = val
			item.isUpdate = 1
			this.formVerify()
		},
		// 是否可编辑
		isFieldDisabled(item) {
			return this.isAutoApply || this.checkrRadonlyByName(item.fieldName)
		},
		checkrRadonlyByName(name) {
			if (!this.isAutoApplyUpdate) return false
			const arr = this.activityDetail.doctorCanEditFields
			return arr ? arr.split(',').indexOf(name) == -1 : true
		},
		checkrRadonly(name, index) {
			const key = name || (this.authForm[index] ? this.authForm[index].fieldName : '')
			return this.checkrRadonlyByName(key)
		},
		// 点击选择地区
		clickSelectArea(index, formatType) {
			if (this.isAutoApply || this.checkrRadonly('', index)) return
			this.areaPickerIndex = index
			this.areaPickerLabel = this.authForm[index].fieldName
			this.areaFormatType = formatType
			this.areaPickerVisible = true
		},
		onAreaConfirm(detail) {
			if (this.areaPickerIndex < 0) return
			let value = detail.province.region_name
			if (detail.city) value += `-${detail.city.region_name}`
			if (detail.area) value += `-${detail.area.region_name}`
			this.inputVal(this.areaPickerIndex, value)
		},
		// 点击选择科室
		clickSelectDept(index) {
			if (this.isAutoApply || this.checkrRadonly('', index)) return
			this.departmentPickerIndex = index
			this.departmentPickerVisible = true
		},
		onDeptConfirm(detail) {
			if (this.departmentPickerIndex < 0) return
			this.selectDeptment = detail
			this.inputVal(this.departmentPickerIndex, detail.name)
		},
		// 点击选择职称 / 下拉选项
		clickSelectTitle(index) {
			if (this.isAutoApply || this.checkrRadonly('', index)) return
			const item = this.authForm[index]
			this.pickerIndex = index
			this.pickerTitle = '选择' + item.fieldName
			this.pickerOptions = item.fieldType === 'title' ? this.titleOptions : item.ext || []
			this.pickerVisible = true
		},
		onPickerConfirm(option) {
			if (this.pickerIndex < 0) return
			this.inputVal(this.pickerIndex, option.text)
		},
		// 点击选择医院
		clickSelectHospital(index) {
			if (this.isAutoApply || this.checkrRadonly('', index)) return
			this.hospitalPickerIndex = index
			this.hospitalPickerVisible = true
		},
		searchHospital(name) {
			return this.$api.cpnt
				.hospitalPage({ nameLike: name, page: 1, limit: 1000 })
				.then((res) => (res.code ? [] : res.data.list || []))
		},
		onHospitalConfirm(item) {
			if (this.hospitalPickerIndex < 0) return
			this.selectHospital = item
			this.inputVal(this.hospitalPickerIndex, item.name)
		},
		// 点击选择开户行
		clickSelectBank(index) {
			if (this.isAutoApply || this.checkrRadonly('', index)) return
			this.bankPickerIndex = index
			this.bankPickerVisible = true
		},
		searchBank(name) {
			return this.$api.cpnt
				.backNamePage({ bank_name: name })
				.then((res) => (res.code ? [] : res.data || []))
		},
		onBankConfirm(item) {
			if (this.bankPickerIndex < 0) return
			const value = item.name || item.bank_name || ''
			// 若当前是支付方式卡片里的开户行，同步更新其展示值（payTypeBankParams 为 authForm 元素的拷贝）
			if (this.payTypeBankParams.bankName && this.payTypeBankParams.bankName.itemIndex === this.bankPickerIndex) {
				this.payTypeBankParams.bankName.fieldValue = value
			}
			this.inputVal(this.bankPickerIndex, value)
		},
		// 点击选择支付方式
		clickSelectPayType(option) {
			this.payTypeItem = option
			this.formVerify()
		},
		// 支付方式银行卡输入
		inputBankBranch(val) {
			if (this.payTypeBankParams.bankBranch) {
				// 同步更新展示值（payTypeBankParams 为 authForm 元素的拷贝）
				this.payTypeBankParams.bankBranch.fieldValue = val
				this.inputVal(this.payTypeBankParams.bankBranch.itemIndex, val)
			}
		},
		inputBankNumber(val) {
			if (this.payTypeBankParams.bankNumber) {
				this.payTypeBankParams.bankNumber.fieldValue = val
				this.inputVal(this.payTypeBankParams.bankNumber.itemIndex, val)
			}
		},
		isValidEmail(email) {
			const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
			return regex.test(email)
		},
		isPureNumberCard(val) {
			return /^\d+$/.test(val)
		},
		// 找到不满组的选项，并给出toast提示，告知为什么不能提交
		clickShowSubmitErrorToast() {
			if (this.isAllowSubmitErrorMessage) {
				this.$toast(this.isAllowSubmitErrorMessage)
			}
		},
		// 点击提交审核
		clickSubmit() {
			const bankNumber = this.authForm.find((item) => item.fieldType == 'bankNumber' || item.field === 'bankNumber')
			const idCard = this.authForm.find((item) => item.fieldType == 'idcard')
			const userName = this.authForm.find((item) => item.fieldType == 'name')
			const emil = this.authForm.find((item) => item.fieldType == 'emil')
			if (bankNumber && bankNumber.fieldValue) {
				// 检测银行卡号只能输入数字
				if (!this.isPureNumberCard(bankNumber.fieldValue)) return this.$toast('银行卡号输入有误')
			}
			if (emil && emil.fieldValue) {
				if (!this.isValidEmail(emil.fieldValue)) return this.$toast('邮箱格式错误')
			}
			if (bankNumber && idCard && userName) {
				// 校验身份证银行卡信息
				this.$api.activity
					.checkBankAndIdCard({
						bankNumber: bankNumber.fieldValue.replace(/\s/g, ''),
						idCard: idCard.fieldValue,
						name: userName.fieldValue,
					})
					.then((res) => {
						if (!res.code) {
							this.submitCallback()
						}
					})
			} else {
				this.submitCallback()
			}
		},
		// 修改资料（自动审核修改模式）
		clickModifyInfor() {
			this.isAutoApply = false
			this.isAutoApplyUpdate = true
		},
		// 提交审核回调
		submitCallback() {
			// 判断是否有协议，有就需要弹出，没有就直接进入
			const isAutoApply = this.isAutoApply
			const { organAutoAudit } = this.activityDetail
			const authForm = JSON.parse(JSON.stringify(this.authForm))
			const update = JSON.stringify(authForm.filter((v) => ['bankNumber', 'bankName'].indexOf(v.fieldType || v.field) == -1)).includes('"isUpdate":1')
			if (organAutoAudit && isAutoApply && !update) {
				this.reportActivity(1)
			} else if (this.activityDetail.agreementUrl) {
				// 存储报名表单数据，供签署页提交使用
				const numberIndex = authForm.findIndex((item) => item.field == 'bankNumber')
				if (numberIndex != -1 && authForm[numberIndex].fieldValue) {
					authForm[numberIndex].fieldValue = authForm[numberIndex].fieldValue.replace(/\s/g, '')
				}
				sessionStorage.setItem('activityReportAuthForm', JSON.stringify({
					selectHospitalId: this.selectHospital ? this.selectHospital.id : '',
					selectDeptmentId: this.selectDeptment ? this.selectDeptment.id : '',
					doctorAutoAudit: update ? 0 : 1,
					isNewInfo: this.publicUserInfo.isNewInfo || 0,
					authForm,
				}))
				this.agreement.visible = true
			} else {
				this.reportActivity()
			}
		},
		// 去报名
		reportActivity(doctorAutoAudit = null) {
			this.loading.submit = true
			const formCommitJson = JSON.stringify(
				this.authForm.map((item) => {
					// 上传字段统一转为 { url } 结构
					if (Array.isArray(item.fieldValue) && item.fieldValue.length && item.fieldValue.some((f) => f && typeof f === 'object' && f.url !== undefined)) {
						return { ...item, fieldValue: item.fieldValue.map((f) => ({ url: f.url })) }
					}
					return item
				})
			)
			this.$api.activity
				.reportActivity({
					id: this.activityDetail.activityDoctorDTO.id,
					activityId: this.options.activityId,
					doctorId: this.doctorId,
					payType: this.payTypeItem.value || '',
					reportParamBody: {
						formCommitJson,
						doctorAutoAudit: doctorAutoAudit === null ? (JSON.stringify(this.authForm).includes('"isUpdate":1') ? 0 : 1) : doctorAutoAudit,
						isNewInfo: this.publicUserInfo.isNewInfo || 0,
						hospitalId: this.selectHospital ? this.selectHospital.id : '',
						deptId: this.selectDeptment ? this.selectDeptment.id : '',
						codeId: this.options.codeId || '',
						activityIdList: [this.options.activityId],
						doctorId: this.doctorId,
						platform: this.activityDetail.platform,
						signUrl: this.publicUserInfo.signUrlOriginal || '',
					},
				})
				.then((res) => {
					this.loading.submit = false
					if (!res.code) {
						if (this.isAutoApply) {
							this.$router.replace(`/activity/sign/audit-result?activityId=${this.options.activityId}&isSubmit=1&type=autoApply`)
						} else if (this.activityDetail.autoAudit === 1) {
							this.$router.replace(`/activity/sign/audit-result?activityId=${this.options.activityId}&isSubmit=1`)
						} else {
							this.$router.replace(`/activity/sign/audit-result?activityId=${this.options.activityId}`)
						}
					}
				})
				.catch(() => {
					this.loading.submit = false
				})
		},
		// 点击去签署
		clickSignUp() {
			if (!this.activityDetail.activityDoctorDTO) {
				Dialog.alert({
					title: '温馨提示',
					message: '当前账号暂时无法报名参与该活动',
					confirmButtonText: '知道了',
				})
				return
			}
			const relationId = this.activityDetail.activityDoctorDTO.id
			const activityId = this.activityDetail.id
			const platform = this.activityDetail.platform
			const autoAudit = this.activityDetail.autoAudit
			const payType = this.payTypeItem.value || ''
			const codeId = this.options.codeId || ''
			this.agreement.visible = false
			this.$router.push(`/activity/sign/signature?activityId=${activityId}&platform=${platform}&relationId=${relationId}&autoAudit=${autoAudit}&payType=${payType}&codeId=${codeId}`)
		},
		// 预览协议图片
		clickPreview() {
			if (!this.activityDetail.agreementUrl) return
			ImagePreview([this.activityDetail.agreementUrl])
		},
		// 关闭协议弹窗
		clickCloseDialog() {
			this.agreement.visible = false
		},
	},
}
</script>

<style lang="less" scoped>
.activity-audit {
	min-height: 100vh;
	background-color: #f7f8fa;
	box-sizing: border-box;
	padding-bottom: 30px;

	&.has-auto-footer {
		padding-bottom: 170px;
	}
}

.audit-notice {
	display: flex;
	align-items: flex-start;
	margin: 12px 12px 0;
	padding: 10px 12px;
	border-radius: 8px;
	background-color: #fff7e7;
	font-size: 12px;
	line-height: 18px;
	color: #8f959e;

	&__icon {
		margin: 1px 6px 0 0;
		font-size: 14px;
		color: var(--color-primary);
		flex-shrink: 0;
	}
}

.audit-loading {
	display: flex;
	justify-content: center;
	padding-top: 120px;
}

.audit-form {
	padding: 12px;

	.audit-card {
		margin-bottom: 12px;
		background-color: #fff;
		border-radius: 10px;
		box-shadow: 0 2px 10px rgba(31, 35, 41, 0.04);
		overflow: hidden;

		// 卡片内字段分隔线
		.audit-field {
			border-bottom: 1px solid #f7f8fa;

			&:last-child {
				border-bottom: none;
			}
		}

		.audit-paytype-notice {
			margin: 0;
			border-radius: 0;
		}

		&__title {
			padding: 14px 16px;
			font-size: 15px;
			font-weight: 500;
			color: #1f2329;
			border-bottom: 1px solid #f5f6f7;
		}

		&__body {
			padding: 14px 16px;
		}
	}
}

.audit-required {
	margin-right: 2px;
	color: #fa5151;
}

.audit-avatar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 14px 16px;

	&__label {
		font-size: 14px;
		color: #1f2329;
	}
}

.audit-paytype-notice {
	display: flex;
	align-items: flex-start;
	margin: 12px 12px 0;
	padding: 10px 12px;
	border-radius: 8px;
	font-size: 12px;
	line-height: 18px;
	color: #ed7a2c;
	background-color: #fff7e7;

	&__icon {
		margin: 1px 6px 0 0;
		font-size: 14px;
		color: #ed7a2c;
		flex-shrink: 0;
	}
}

.audit-sign {
	width: 100%;
	vertical-align: middle;
	border-radius: 8px;
}

.audit-submit {
	&__footer {
		padding: 24px 0;
	}

	&__btn {
		height: 48px;
		border-radius: 24px;
		font-size: 16px;
		font-weight: 500;

		&--disabled {
			opacity: 0.5;
		}
	}
}

.audit-auto-footer {
	width: 100%;

	&__bar {
		display: flex;
		align-items: center;
	}

	&__sub {
		flex: 3;
		padding-right: 12px;

		.van-button {
			border-radius: 24px;
		}
	}

	&__main {
		flex: 5;

		.van-button {
			border-radius: 24px;
		}
	}

	&__desc {
		padding-top: 12px;
		font-size: 12px;
		text-align: center;
		color: #8f959e;
	}
}

.audit-agreement {
	width: 90%;
	border-radius: 12px;

	&__title {
		position: relative;
		padding: 20px 40px 0;
		font-size: 16px;
		font-weight: 500;
		text-align: center;
		color: #1f2329;
	}

	&__close {
		position: absolute;
		top: 22px;
		right: 14px;
		font-size: 18px;
		color: #8f959e;
	}

	&__body {
		height: 300px;
		margin: 14px;
		padding: 14px;
		overflow-y: auto;
		box-sizing: border-box;
		border-radius: 8px;
		background-color: #f5f6f7;
	}

	&__img {
		width: 100%;
		vertical-align: middle;
	}

	&__handle {
		width: 40%;
		margin: 0 auto 20px;

		.van-button {
			border-radius: 24px;
		}
	}
}
</style>
